import styled from 'styled-components';
import { font, space, color, query } from '@design/templateFns';

import { CarouselNavButtonWrapper } from '@components/MiscComponents/GridAndCarouselComponents/index';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';

//  default swiper styles

// TOP SECTION
export const TopContainer = styled.div`
  margin-bottom: ${space('lg')};
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (${query.atLeast('tablet')}) {
    margin-bottom: ${space('x7')};
  }
`;

export const Heading = styled.h2`
  padding: 0;
  margin-bottom: ${space('sm')};
  ${font('headline-xs')}

  @media screen and (${query.atLeast('tablet')}) {
    ${font('headline-md')}
  }
`;

export const Body = styled.div`
  margin: 0;
  padding: 0;
  max-width: 500px;
  width: 100%;
  color: ${color('gray5')};
  ${font('body-sm-light')}
  @media screen and (${query.atLeast('tablet')}) {
    ${font('body-md-light')}
  }
`;

// Slider

export const SliderContainer = styled.div`
  margin: 0 auto;

  .swiper {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    /* Fix of Webkit flickering */
    z-index: 1;
  }
  .swiper-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    transition-property: transform;
    box-sizing: content-box;
  }
  .swiper-android .swiper-slide,
  .swiper-wrapper {
    transform: translate3d(0px, 0, 0);
  }
  .swiper-pointer-events {
    touch-action: pan-y;
  }
  .swiper-pointer-events.swiper-vertical {
    touch-action: pan-x;
  }
  .swiper-slide {
    flex-shrink: 0;
    width: 100%;
    height: 100%;
    position: relative;
    transition-property: transform;
  }
  .swiper-slide-invisible-blank {
    visibility: hidden;
  }
`;

export const StyledSwiperSlide = styled(SwiperSlide)`
  a {
    position: relative;
    display: block;
    width: 100%; // The carousel dictates the width from "slidesPerView", so this is 100%
    height: 0; // padding trick to make it square and responsive
    padding-bottom: 100%;
    cursor: pointer;
  }
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &::after {
    // there is an overlay in figma
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.05);
    transition: background-color 0.3s ease;
  }
  &:hover {
    // very slight hover state
    &::after {
      background-color: rgba(0, 0, 0, 0.1);
    }
  }
  span {
    ${font('eyebrow-md')};
    color: ${color('bg')};
    text-transform: uppercase;
    position: absolute;
    text-align: center;
    z-index: 1;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const ButtonContainer = styled(CarouselNavButtonWrapper)`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${space('sm')};
  margin-top: ${space('x5')};
  @media screen and (${query.atLeast('tablet')}) {
    margin-bottom: ${space('x7')};
  }
`;
